import React from "react";
import { compose, withProps, lifecycle, withState, withHandlers } from "recompose";
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker
} from "react-google-maps";
import SearchBox from "react-google-maps/lib/components/places/SearchBox";


import { convertGoogleMapPlaceToValue } from "../../utils/utils";


/*eslint-disable no-undef*/

const PlayerLocationMap = compose(
	withState("currentLocationValue", "setCurrentLocationValue", {}),
	withState("places", "setPlaces", []),
	withState("center", "setCenter", { lat: -34.397, lng: 150.644 }),
	withProps((props) => {

		let newProps = {
			googleMapURL:
				"https://www.google.com", //placeholder so we can use single instance of API between different components
			loadingElement: <div style={{ height: "100%" }} />,
			containerElement: <div className="player-location-map" />,
			mapElement: <div style={{ height: "100%" }} />,
			currentLocationValue: props.value
		};

		return newProps;
	}),
	withHandlers({
		onChangeInternal: props => value => {

			props.setCurrentLocationValue(value);           
			if(props.onChange) {
				props.onChange(value);
			}
		}
	}),
	withHandlers({
		onClickMap: (props) => event => {
			let latLng = event.latLng;
			let value = {longitude:latLng.lng(), latitude:latLng.lat()};    
			props.setCurrentLocationValue(value);
			props.onChangeInternal(value);
		}  
	}),
	withHandlers({
		onClickMarker: (props) => place => {
			let placeValue = convertGoogleMapPlaceToValue(place);                 
			props.onChangeInternal(placeValue);
		}  
	}),
	withScriptjs,
	withGoogleMap,
	lifecycle({

		componentWillMount() {

			const refs = {};


			let state = {
				bounds: null,
				markers: [],
				onMapMounted: ref => {
					refs.map = ref;
				},
				onBoundsChanged: () => {
					this.setState({
						bounds: refs.map.getBounds(),
						center: refs.map.getCenter(),
					});
				},
				onSearchBoxMounted: ref => {
					refs.searchBox = ref;
				},
				onPlacesChanged: () => {
					const places = refs.searchBox.getPlaces();

					let place, latLng, latLngObj;

					if (places.length === 1) {
						place = places[0];

						latLng = place.geometry.location;
						latLngObj = { lat: latLng.lat(), lng: latLng.lng() };

						let placeValue = convertGoogleMapPlaceToValue(place);
						this.props.onChangeInternal(placeValue);

						this.props.setPlaces([]);
						this.props.setCenter(latLngObj);

					} else if (places.length > 1) {

						place = places[0];

						latLng = place.geometry.location;
						latLngObj = { lat: latLng.lat(), lng: latLng.lng() };

						this.props.onChangeInternal({});

						this.props.setPlaces(places);
						this.props.setCenter(latLngObj);
					}
				}
			};

			if (this.props.value) {
				this.props.setCenter({ lat: this.props.value.latitude, lng: this.props.value.longitude });
			}

			this.setState(state);
		}
	}),
)((props) => {

	let currentLocationMarker;
	if (props.currentLocationValue) {
		let currentLocationValue = props.currentLocationValue;
		currentLocationMarker = <Marker position={{ lat: currentLocationValue.latitude, lng: currentLocationValue.longitude }} />;
	}

	let markers = [];
	if (props.places) {
		markers = props.places.map((place, idx) => {
			let location = place.geometry.location;
			return <Marker key={"marker-" + idx} position={{ lat: location.lat(), lng: location.lng() }} onClick={() => { props.onClickMarker(place); }} />;
		});
	}

	return (
		<GoogleMap defaultZoom={8} center={props.center} onClick={props.onClickMap} options={{ streetViewControl: false, fullscreenControl: false, mapTypeControl: false}}>
			<SearchBox
				ref={props.onSearchBoxMounted}
				bounds={props.bounds}
				onPlacesChanged={props.onPlacesChanged}
				controlPosition={google.maps.ControlPosition.TOP_LEFT}>
				
				<input
					type="text"
					placeholder="Search"
					style={{
						boxSizing: "border-box",
						border: "1px solid transparent",
						width: "100%",
						maxWidth: "300px",
						height: "32px",
						margin: "10px",
						padding: "0 12px",
						borderRadius: "3px",
						boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
						fontSize: "14px",
						outline: "none",
						textOverflow: "ellipses",
					}}
				/>
			</SearchBox>
			{currentLocationMarker}
			{markers}
		</GoogleMap>
	);
});

export default PlayerLocationMap;

/*eslint-disable no-undef*/